







import { Component, Vue } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'
import DocumentSheet from '@/components/DocumentSheet.vue'  // @ is an alias to /src

@Component({
  components: {
    DocumentSheet,
  },
})
export default class Invoice extends Vue {

  @Action('firestore/fetchInvoices')
  private fetchInvoices!: () => Promise<void>

  @Getter('firestore/invoice')
  private readInvoice!: (invoiceId: string) => Invoice|undefined

  private get invoice(): Invoice|undefined {
    return this.readInvoice(this.invoiceId)
  }

  private get invoiceId(): string {
    return this.$route.params.invoice_id
  }

  public mounted() {
    this.fetchInvoices()
  }
}
